import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import { Carousel } from 'react-responsive-carousel';
import '../../styles/Home.css';
import { useState, useRef } from "react";
import { AnimatedDiv } from "../ui/Animations";
import { motion, AnimatePresence } from "framer-motion"; // pour une belle animation
import cave from '../../assets/cave.png';
import frog from '../../assets/frog.png';
import carouselData from "../../data_assets/carouselData.json"

export function Presentation() {
    const [showFrogStory, setShowFrogStory] = useState(false);
// 1. État pour la modale vidéo
    const [isVideoOpen, setIsVideoOpen] = useState(false);
    const modalVideoRef = useRef(null);

    const openVideoModal = () => {
        setIsVideoOpen(true);
        // On bloque le scroll de la page en arrière-plan
        document.body.style.overflow = 'hidden';
    };

    const closeVideoModal = () => {
        setIsVideoOpen(false);
        document.body.style.overflow = 'unset';
    };
    return (
        <div className="presentation_size_all">
            <div className="presentation_content1">
               <AnimatedDiv delay={0.3}>
                    <div className="presentation_video_container" onClick={openVideoModal}>
                        <video 
                            src="https://erwantapparel.ch/video/Video_presentation.mp4"
                            autoPlay 
                            loop 
                            muted 
                            playsInline
                            className="presentation_video_element"
                        />
                        {/* Un overlay au survol pour indiquer qu'on peut cliquer */}
                    <div className="video_hover_overlay">
                        <span className="play_icon">▶</span>
                        <span className="play_text">Regarder avec le son</span>
                    </div>
                    </div>
                </AnimatedDiv>

                <div className='presentation_text1'>
                      <AnimatedDiv delay={0.5}>
                        <p className="text-large">
                            Situé au cœur du Valais, la cave du Sonneur vous ouvre ses portes dans un univers viticole et musical.
                        </p>       
                        <div className="poem_wrapper">
                        <p className="text-medium">
                            Sonneur et vigneron, Breton et Valaisan, découvre des vins pleins d’embruns et empli de générosité.
                            <br/> Erwan, le sonneur de l’étape, te fera voyager au rythme du Rhône et au gré des tempêtes.
                        </p>
                     
                   </div>
                    </AnimatedDiv>
                </div>
            </div>
            {/* SECTION 2 : IMAGE CAVE + LOGO INTERACTIF (Nouveau) */}
            <div className="presentation_content2">
                <AnimatedDiv delay={0.4}>
                    <div className="presentation_image_container">
                        <img
                            src={cave}
                            alt="La cave du Sonneur"
                            className="presentation_image2"      
                        />
                    </div>
                </AnimatedDiv>
<div className="presentation_text2">
                    <AnimatedDiv delay={0.6}>
                        {/* LOGO PULSANT DU CRAPAUD SONNEUR */}
                        <div className="frog_interaction_wrapper">
                            <motion.div 
                                className="frog_pulse_logo"
                                animate={{ scale: [1, 1.08, 1] }}
                                transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
                                onClick={() => setShowFrogStory(!showFrogStory)}
                                style={{ cursor: 'pointer', fontSize: '2.5rem', textAlign: 'center' }}
                            >
                                <img 
                                src={frog}
        alt="Grenouille Cave du Sonneur" 
        style={{ width: '3rem', height: '3rem', objectFit: 'contain' }} 
      />
                            </motion.div>
                            <p className="click_prompt" onClick={() => setShowFrogStory(!showFrogStory)}>
                                *Pourquoi le "Sonneur" ? Cliquez sur le crapaud...*
                            </p>

                            {/* TEXTE EXPLICATIF S'ACHEMINANT AVEC ANIMEPRESENCE */}
                            <AnimatePresence>
                                {showFrogStory && (
                                    <motion.div 
                                        className="frog_story_box"
                                        initial={{ opacity: 0, height: 0 }}
                                        animate={{ opacity: 1, height: "auto" }}
                                        exit={{ opacity: 0, height: 0 }}
                                    >
                                        <p className="text-medium story_highlight">
                                            On appelle un joueur de cornemuse un sonneur. <br />
                                            Dans la nature, le crapaud sonneur accompagne les cycles, entre la terre et l’eau. <br />
                                            C’est de cette rencontre vibrante qu’est née la cave.
                                        </p>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>

                        <div className="poem_seasonal">
                            <p className="text-medium italic_poem">
                                "Le bourdonnement alpin joue avec l'eau <br/> Puisque Artemis résonne au rythme des flots"
                            </p>
                            <p className="text-medium italic_poem">
                                "Les rayons réchauffent et dissipent le brouillard <br/> Pour que les pas recueillissent le nectar"
                            </p>
                            <p className="Poeme_style">- Erwan Tapparel -</p>
                        </div>
                    </AnimatedDiv>
                </div>
            </div>




        <div className="presentation_location_info">
    <div className="location_divider"></div>
    <p  className="text-large" >Où nous trouver ?</p>
        <p className="location_address">📍 Chemin des Cyprès 17, 3960 Sierre</p>
    
    <a href="https://maps.google.com/?q=Chemin+des+Cyprès+17,+3960+Sierre" target="_blank" rel="noopener noreferrer" className="map_button">
        Ouvrir dans Google Maps
    </a>

        </div>
        <AnimatePresence>
                {isVideoOpen && (
                    <motion.div 
                        className="video_modal_backdrop"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={closeVideoModal} // Ferme si on clique à côté de la vidéo
                    >
                        <motion.div 
                            className="video_modal_content"
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.9, opacity: 0 }}
                            onClick={(e) => e.stopPropagation()} // Empêche la fermeture si on clique SUR la vidéo
                        >
                            {/* Bouton Fermer (X) */}
                            <button className="video_modal_close" onClick={closeVideoModal}>×</button>
                            
                            {/* La vidéo en grand avec contrôles et SON activé */}
                            <video 
                                ref={modalVideoRef}
                                src="https://erwantapparel.ch/video/Video_presentation.mp4" 
                                controls 
                                autoPlay 
                                playsInline
                                className="video_fullscreen_element"
                            />
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );    
}
/*
export function PopupEvent({ delay = 2000 }) {
    const [showPopup, setShowPopup] = useState(false);
const POPUP_KEY = "popupEvent_v2";
    //Display popup before 1s on this page
      useEffect(() => {
    const hasSeenPopup = localStorage.getItem(POPUP_KEY);
    if (hasSeenPopup) return; // ne rien faire si déjà affiché

    // Sinon, planifie l'affichage du popup
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, delay);
    // Nettoyage si le composant se démonte avant la fin du timer
    return () => clearTimeout(timer);
}, [delay]); // <- fermeture correcte
       

    const handleClose = () => {
        setShowPopup(false);
  localStorage.setItem(POPUP_KEY, "true");    };

    if (!showPopup) return null;

     return (
       <AnimatePresence>
      {showPopup && (
        <motion.div
          className="page-popup-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
             className="page-popup-box"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 100, damping: 15 }}
          >
             <button
              onClick={handleClose}
              className="page-popup-close"
            >
              X
            </button>
            <h2 >Porte ouvertes à la cave - Muraz</h2>
            <p> 📅 Samedi 13 & 20 décembre <br/> 16h00 à 20h00 </p>
            <p> 📅 Dimanche 14 & 21 décembre <br/> 11h00 à 14h00 </p>
            <p> 📍 Muraz - Chemin des Cyprès 17</p>
           
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
    );
}
    */
export function Welcome() {
    const [carouselImages] = useState(carouselData);

    // Fonction pour scroller doucement vers la présentation
    const scrollToNextSection = () => {
        window.scrollTo({
            top: window.innerHeight * 0.8, // Descend d'environ 80% de la hauteur de l'écran
            behavior: 'smooth'
        });
    };
    return (
        
          <div className="carousel-container">
       {Array.isArray(carouselImages) && carouselImages.length > 0 && (
            <>
            <Carousel
                autoPlay
                interval={9000}      // temps entre les slides
                infiniteLoop
                showIndicators={false}
                showStatus={false}
                stopOnHover={false}  // continue même si la souris est dessus
                swipeable
            >
               {carouselImages
                    .map(e => (
                        <div className="slide" key={e.id}>
                            <img src={e.imageURL} alt={e.legend} />
                            <div className="overlay">
                                <h1 className="overlay_title">Cave du Sonneur</h1>
                                <p className="overlay_text">{e.text}</p>
                            </div>
                        </div>
                    ))}
            </Carousel>
{/* LA FLÈCHE DE SCROLL */}
                    <div className="scroll-down-indicator" onClick={scrollToNextSection}>
                       
                        <div className="arrow">
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </>
        )}
    </div>
);

}

